// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"TermsOfService-module__checkbox___O1xiA","label":"TermsOfService-module__label___3aNfZ"};